module.exports = __webpack_public_path__ + "img/Datenbankswitch.9312eae0.png";